export const awsResources: any = {
  baseUrl: {
    main: 'https://wxb4g3h8o2.execute-api.ap-northeast-1.amazonaws.com/main',
    reminderManage: 'https://cva54o1rcj.execute-api.ap-northeast-1.amazonaws.com/main',
    dbAccess: 'https://kepabyztue.execute-api.ap-northeast-1.amazonaws.com/main',
  },
  userPoolId: {
    userAccount: 'ap-northeast-1_XTH2GNRQ5',
  },
  userPoolClientId: {
    userAccount: '5es41np4835d1lrjsva5e9avpc',
  },
};
